import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import useLocationHistoryService from "../../api/services/useLocationHistoryService";
import useStandService from "../../api/services/useStandService";
import {getMediaThumbSrc} from "../../helpers/mediaUrl";
import Loading from "../../components/Loading/Loading";
import Button from "../../components/Button/Button";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";
import useFunction from "../../hooks/useFunction";
import swal from "sweetalert";


const UserStandLocationHistory = () => {

  const {standId} = useParams()
  const {date} = useFunction()
  const {userShow: standShow} = useStandService()
  const {userShowCollection, userDelete} = useLocationHistoryService(standId)

  const [stand, setStand] = useState(null)
  const [entries, setEntries] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    standShow((data) => setStand(data), () => {}, standId)
    userShowCollection(
      (data) => {
        const sorted = (data || []).sort((a, b) => {
          const dateA = a.date_from || a.created_at || ''
          const dateB = b.date_from || b.created_at || ''
          return dateB.localeCompare(dateA)
        })
        setEntries(sorted)
        setIsLoading(false)
      },
      () => setIsLoading(false),
    )
  }, [standId])

  const formatDateRange = (entry) => {
    const parts = []
    if (entry.date_from) parts.push(date(entry.date_from))
    if (entry.date_to) parts.push(date(entry.date_to))
    if (parts.length === 2) return parts[0] + ' t/m ' + parts[1]
    if (parts.length === 1) return parts[0]
    if (entry.created_at) return date(entry.created_at)
    return null
  }

  const handleDelete = (entry) => {
    swal({
      title: 'Verwijderen?',
      text: 'Weet je zeker dat je deze plek wilt verwijderen?',
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {text: 'Annuleren', value: null, visible: true, className: 'btn-color-grey btn-size-m', closeModal: true},
        confirm: {text: 'Verwijderen', value: true, visible: true, className: 'btn-color-red btn-size-m', closeModal: true}
      }
    }).then((result) => {
      if (result) {
        userDelete(
          () => {
            setEntries(prev => prev.filter(e => e.id !== entry.id))
            swal({title: 'Verwijderd', icon: 'success', timer: 1000, buttons: false})
          },
          () => {},
          entry.id,
        )
      }
    })
  }

  return (
    <div className="page-user-stand-location-history">
      <div className="row">
        <div className="col">
          <h1>Waar geweest{stand ? ': ' + stand.label : ''}</h1>
          <p>Laat locatie-eigenaren zien waar je eerder hebt gestaan. Plekken die je toevoegt verschijnen op je profiel en bouwen vertrouwen op bij potentiële opdrachtgevers. Foto's worden automatisch aan je galerij toegevoegd. Geaccepteerde boekingen verschijnen hier vanzelf.</p>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup location={'/user/stand/' + standId + '/locaties'}/>
        </div>
      </div>

      <div className="row buttons">
        <Button label={'Alle stands'} link={'/user/stands'}/>
        <Button
            label="+ Plek toevoegen"
            link={'/user/stand/' + standId + '/locaties/new'}
        />
      </div>

      {isLoading ? <Loading/> :
        <div className="location-entries">
          {entries.length === 0 &&
            <p className="empty-state">Nog geen plekken toegevoegd. Voeg een plek toe waar je hebt gestaan!</p>
          }
          {entries.map((entry) => {
            const thumbSrc = getMediaThumbSrc(entry.media)
            const dateRange = formatDateRange(entry)
            const isManual = entry.source === 'manual'

            return (
              <div key={entry.id} className="location-entry">
                <div className="image">
                  {thumbSrc
                    ? <img src={thumbSrc} alt={entry.label} loading="lazy"/>
                    : <div className="no-image">📍</div>
                  }
                </div>
                <div className="col-mid">
                  <div className="entry-header">
                    <h4>{entry.label}</h4>
                    {entry.source === 'booking'
                      ? <span className="badge badge-booking">Via boeking</span>
                      : <span className="badge badge-manual">Handmatig</span>
                    }
                  </div>
                  <div className="entry-meta">
                    {entry.city && <p className="city">{entry.city}</p>}
                    {entry.description && <p className="description">{entry.description}</p>}
                  </div>
                </div>
                <div className="col-right">
                  {isManual &&
                    <>
                      <Button label="Bewerk" size="s" color="green" link={'/user/stand/' + standId + '/locaties/' + entry.id + '/edit'}/>
                      <Button label="Verwijder" size="xs" color="red" onClick={() => handleDelete(entry)}/>
                    </>
                  }
                  <div className="meta">
                    {dateRange && <p>{dateRange}</p>}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      }
    </div>
  )
}

export default UserStandLocationHistory
